

























































import {Component, Vue, Watch} from "vue-property-decorator";
import {isRegisterUrl, isResetUrl, isValidationUrl, isLoginUrl} from '@/services/routeHelper';
import {OTHER_ROUTES, VIEW_OPTIONS, LOGIN_ROUTES} from "@/constants/routes";

import LoginForm from "@/views/components/LoginRegister/components/LoginForm.vue";
import RegisterForm from "@/views/components/LoginRegister/components/RegisterForm.vue";
import SendResetPassword from "@/views/components/LoginRegister/components/SendResetPassword.vue";
import ResetPasswordForm from "@/views/components/LoginRegister/components/ResetPasswordForm.vue";
import ValidateAccountView from "@/views/components/LoginRegister/components/ValidateAccountView.vue";
import {userHasLoggedBefore} from "@/helpers/localStoragehandler";


@Component({
  name: "LoginRegister",
  components: {
    LoginForm,
    RegisterForm,
    SendResetPassword,
    ResetPasswordForm,
    ValidateAccountView,
  },
})
export default class LoginRegister extends Vue {
  private currentView: VIEW_OPTIONS = VIEW_OPTIONS.IS_LOGIN;

  @Watch("$route") // checks if the route change to reset or register
  private checkRoute() {
    if (isRegisterUrl(this.$route)) {
      this.currentView = VIEW_OPTIONS.IS_REGISTER;
    } else if (isResetUrl(this.$route)) {
      this.currentView = VIEW_OPTIONS.IS_RESET;
    } else if (isValidationUrl(this.$route)) {
      this.currentView = VIEW_OPTIONS.IS_VALIDATION;
    } else if (isLoginUrl(this.$route)) {
      this.currentView = VIEW_OPTIONS.IS_LOGIN;
    } else {
      this.currentView = userHasLoggedBefore()
          ? VIEW_OPTIONS.IS_LOGIN
          : VIEW_OPTIONS.IS_REGISTER;
    }
  }

  private get viewIsLogin(): boolean {
    return this.currentView === VIEW_OPTIONS.IS_LOGIN;
  }

  private get viewIsValidationAccount(): boolean {
    return this.currentView === VIEW_OPTIONS.IS_VALIDATION;
  }

  private get viewIsRegister(): boolean {
    return this.currentView === VIEW_OPTIONS.IS_REGISTER;
  }

  private get viewIsSendPasswordReset(): boolean {
    return this.currentView === VIEW_OPTIONS.IS_SEND_RESET;
  }

  private get viewIsPasswordReset(): boolean {
    return this.currentView === VIEW_OPTIONS.IS_RESET;
  }

  private created() {
    this.checkRoute();
  }

  private toggleRegister() {
    this.currentView === VIEW_OPTIONS.IS_REGISTER
        ? this.goToLogin()
        : this.goToRegister();
  }

  private toggleGoToSendReset() {
    this.currentView = this.currentView === VIEW_OPTIONS.IS_SEND_RESET
        ? VIEW_OPTIONS.IS_LOGIN
        : VIEW_OPTIONS.IS_SEND_RESET;
  }

  private backToLogin() {
    if (!isLoginUrl(this.$route)) {
      this.goToLogin();
    } else {
      this.currentView = VIEW_OPTIONS.IS_LOGIN;
    }
  }

  private clearUrl() {
    this.$router.push({ name: OTHER_ROUTES.HOME });
  }

  private goToLogin() {
    this.$router.push({ name: LOGIN_ROUTES.LOGIN });
  }

  private goToRegister() {
    this.$router.push({ name: LOGIN_ROUTES.REGISTER });
  }

  private goToReset() {
    this.$router.push({ name: LOGIN_ROUTES.RESET });
  }
}
